export const SHOW_DISTANCE_WARNING_THRESHOLD_IN_MILES = 60;
